import { render } from "./ModalInventoryProperties.vue?vue&type=template&id=40eca820&scoped=true"
import script from "./ModalInventoryProperties.vue?vue&type=script&lang=js"
export * from "./ModalInventoryProperties.vue?vue&type=script&lang=js"

import "./ModalInventoryProperties.vue?vue&type=style&index=0&id=40eca820&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40eca820"]])

export default __exports__